export default __webpack_public_path__ + "static/colour-pigment-0e66a57e12c2af37b2161e2c82de3f6d.jpg";